import React, {useEffect, useState} from 'react'
import './App.css';

import firebase from "firebase";

function App() {

    const [data, setData] = useState(null);
    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
        if (!isLoaded) {
            const firebaseConfig = {
                apiKey: "AIzaSyAiPD3lkivAknlG0lT8VgVDnbvsWpoIicg",
                authDomain: "kama-db032.firebaseapp.com",
                projectId: "kama-db032",
                storageBucket: "kama-db032.appspot.com",
                messagingSenderId: "683851958212",
                appId: "1:683851958212:web:1f2d7c91e8723086394691",
                measurementId: "G-P3G9L6KFD3"
            };
            console.log(firebase);
            firebase.initializeApp(firebaseConfig);
            setIsLoaded(true);
        }

        firebase.firestore().collection('data').doc('data').onSnapshot(snap => {
            setData(snap.data())
        })
    }, [])

    return (
        <div className="App">
            {/*<header className="App-header">*/}
            {/*  <img src={logo} className="App-logo" alt="logo" />*/}
            {/*  <p>*/}
            {/*    Edit <code>src/App.js</code> and save to reload.*/}
            {/*  </p>*/}
            {/*  <a*/}
            {/*    className="App-link"*/}
            {/*    href="https://reactjs.org"*/}
            {/*    target="_blank"*/}
            {/*    rel="noopener noreferrer"*/}
            {/*  >*/}
            {/*    Learn React*/}
            {/*  </a>*/}
            {/*</header>*/}
            {data ? (
                <div style={{width: "100%", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center"}}>
                    <br/> <br/><br/> <br/>
                    {/*BTC $ {fixNum(data.btc)} | ETH $ {fixNum(data.eth)} <br/> <br/>*/}
                    <div
                        style={{
                            display: "flex",
                            "height": "160px",
                            "backgroundColor": "#FFFFFF",
                            "overflow": "hidden",
                            "boxSizing": "border-box",
                            "border": "1px solid #56667F",
                            "borderRadius": "4px",
                            "textAlign": "right",
                            "lineHeight": "14px",
                            "fontSize": "12px",
                            "fontFeatureSettings": "normal",
                            "textSizeAdjust": "100%",
                            "boxShadow": "inset 0 -20px 0 0 #56667F",
                            "padding": "0px",
                            "margin": "0px",
                            "width": "300px"
                        }}>
                        <div style={{
                            "height":"150px",
                            "padding":"0px","margin":"0px","width":"300px"}}>
                            <iframe
                                src="https://widget.coinlib.io/widget?type=full_v2&theme=light&cnt=2&pref_coin_id=1505&graph=yes"
                                width="100%" height="232px" scrolling="auto" marginWidth="0" marginHeight="0"
                                frameBorder="0" border="0" style={{"border":"0","margin":"0","padding":"0"}}></iframe>
                        </div>
                    </div>
                    <br/> <br/>
                    $ {fixNum(data.usd)} ✝️ 🚨 <br/> <br/>
                    ₪ {fixNum(data.ils)} 🕎 🚨 <br/> <br/>
                    last updated {data.lastUpdated.toDate().toLocaleString()}
                </div>
            ) : <div>Loading</div>}

        </div>
    );
}

function fixNum(n) {
    return Number(n).toLocaleString('en', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    })
}

export default App;
